var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"modalId":"modalImage","load":false,"typeLg":"modal_md","aria-hidden":"true"}},[_c('img',{attrs:{"src":this.image,"alt":""},on:{"mouseout":function($event){return _vm.closeModalImage()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }